module.exports = __webpack_public_path__ + "img/func3.12f0f6e9.png";